angular.module('user-group')
    .component('userGroupList', {
        bindings: {
            items: '<'
        },
        template: `
            <div class="col-sm-12 document_user_column">
                <div class="user-group-style" ng-repeat="e in $ctrl.items | orderBy: 'name' track by e.id">{{e.name}}</div>
            </div>
        `,
    })
